import * as  types from './mutation-types'
import initialState from './state'

export default {
  [types.EMPTY_ALL]: (state) => {
    Object.assign(state, initialState)
  },
  [types.SET_USER]: (state, obj) => {
    state.user = obj.user
  },
  [types.SET_ANOS]: (state, obj) => {
    state.anos = obj.anos
  },
  [types.SET_MESES]: (state, obj) => {
    state.meses = obj.meses
  },
  [types.SET_ANO_SELECTED]: (state, obj) => {
    state.anoSelected = obj.anoSelected
  },
  [types.SET_MES_SELECTED]: (state, obj) => {
    state.mesSelected = obj.mesSelected
  },
  [types.SET_CENTRO_CUSTO]: (state, obj) => {
    state.centroCusto = obj.centroCusto
  },
  [types.SET_CENTRO_CUSTO_LIST]: (state, obj) => {
    state.centroCustoList = obj.centroCustoList
  },
  [types.SET_COMPETENCIA_OPEN]: (state, obj) => {
    state.competenciaOpen = obj.competenciaOpen
  },
  [types.SET_COMPETENCIA_LIST]: (state, obj) => {
    state.competenciaList = obj.competenciaList
  },
  [types.SET_CENTRO_CUSTO_SELECTED]: (state, obj) => {
    state.centroCustoSelected = obj.centroCustoSelected
  },
  [types.SET_COMPETENCIA_SELECTED]: (state, obj) => {
    state.competenciaSelected = obj.competenciaSelected
  },
  [types.SET_FILTER_UPDATE_AT]: (state, obj) => {
    state.filterUpdatedAt = obj.filterUpdatedAt
  },
  [types.SET_USER_LIST]: (state, obj) => {
    state.userList = obj.userList
  },
  [types.SET_ARVORE_LIST]: (state, obj) => {
    state.arvoreList = obj.arvoreList
  },
  [types.SET_PERIODO_LIST]: (state,obj) => {
    state.periodoList = obj.periodoList
  },
  [types.SET_PERIODO_SELECTED]: (state,obj) => {
    state.periodoSelected = obj.periodoSelected
  },
  [types.SET_REDIRECT]: (state,obj) => {
    state.redirect = obj.redirect
  },
  [types.SET_PROCESSO_LIST]: (state,obj) => {
    state.processoList = obj.processoList
  },
  [types.SET_INDICADOR_LIST]: (state,obj) => {
    state.indicadorList = obj.indicadorList
  }
}



// WEBPACK FOOTER //
// ./src/store/mutations.js